var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInProgress = function SvgInProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 74 74"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.1,
    cy: 38.1,
    r: 35.1,
    fill: "#2bd675"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.034 20.508a3.908 3.908 0 1 1-5.528 5.527 17.181 17.181 0 1 0 0 24.299 3.908 3.908 0 1 1 5.527 5.527 25 25 0 1 1 0-35.353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m54.074 28.92-10.861-.27a1.1 1.1 0 0 1-.581-.188 1.1 1.1 0 0 1-.395-.476 1.05 1.05 0 0 1-.073-.601c.035-.2.13-.383.271-.524l10.591-10.59a.98.98 0 0 1 .524-.27c.2-.035.41-.009.6.074.192.084.357.22.475.394.118.173.184.375.19.58l.27 10.86q.007.206-.067.396a.96.96 0 0 1-.944.615"
  })));
};
export default SvgInProgress;